import { type FC, type ReactNode } from 'react';

import Badge, { type BadgeProps } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    border: `1px solid ${theme.palette.background.paper}`,
  },
}));

interface NotClearedAvatarBadgeProps {
  readonly children: ReactNode;
  readonly isEnabled?: boolean;
}

export const NotClearedAvatarBadge: FC<NotClearedAvatarBadgeProps> = ({ children, isEnabled }) =>
  isEnabled ? (
    <StyledBadge
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom',
      }}
      color='warning'
      overlap='circular'
      variant='dot'
    >
      {children}
    </StyledBadge>
  ) : (
    children
  );
